{
  "name": "eurovolc-gui",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve ev-gui --configuration development",
    "start:prod": "ng serve ev-gui --configuration production",
    "start:ci": "ng serve",
    "build": "ng build",
    "build:prod": "ng build --configuration production",
    "test": "ng test --watch=false",
    "lint": "eslint",
    "lint:fix": "eslint --fix",
    "lint:quiet": "eslint --quiet --fix",
    "lint:scss": "echo 'WIP: Stylelint is not very installed/configured.'",
    "prepare": "husky install",
    "e2e": "pnpm exec playwright test --trace on",
    "e2e-debug": "PWDEBUG=1 pnpm exec playwright test",
    "ci-e2e": "pnpm exec playwright test --trace on",
    "generate-test": "pnpm exec playwright codegen http://localhost:4200"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "20.3.33",
    "@angular/cdk": "20.2.4",
    "@angular/common": "20.3.33",
    "@angular/compiler": "20.3.33",
    "@angular/core": "20.3.33",
    "@angular/forms": "20.3.33",
    "@angular/material": "20.2.4",
    "@angular/material-moment-adapter": "20.2.4",
    "@angular/platform-browser": "20.3.33",
    "@angular/platform-browser-dynamic": "20.3.33",
    "@angular/router": "20.3.33",
    "@danielmoncada/angular-datetime-picker": "20.0.1",
    "@fortawesome/fontawesome-free": "^6.0.0",
    "@turf/turf": "^6.5.0",
    "@types/esri-leaflet-geocoder": "^2.2.8",
    "esri-leaflet": "^3.0.2",
    "esri-leaflet-geocoder": "^3.1.0",
    "geojson": "^0.5.0",
    "jquery": "^3.5.1",
    "jquery-ui-dist": "^1.12.1",
    "leaflet": "^1.7.1",
    "leaflet-draw": "^0.4.13",
    "leaflet-wfst": "^2.0.1-beta.25",
    "leaflet.heat": "^0.2.0",
    "leaflet.markercluster": "^1.4.1",
    "mime": "^3.0.0",
    "moment": "2.29.4",
    "rxjs": "^7.4.0",
    "tslib": "^2.0.0",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/architect": "0.2003.20",
    "@angular-devkit/build-angular": "20.3.33",
    "@angular-devkit/core": "20.3.33",
    "@angular-devkit/schematics": "20.3.33",
    "@angular/cli": "20.3.33",
    "@angular/compiler-cli": "20.3.33",
    "@angular/language-service": "20.3.33",
    "@commitlint/cli": "20.4.2",
    "@commitlint/config-conventional": "20.4.2",
    "@eslint/js": "^10.0.1",
    "@playwright/test": "1.64.1",
    "@types/esri-leaflet": "^2.1.9",
    "@types/jquery": "^3.5.14",
    "@types/leaflet": "^1.7.9",
    "@types/leaflet-draw": "^1.0.5",
    "@types/leaflet.heat": "^0.2.1",
    "@types/leaflet.markercluster": "^1.4.6",
    "@types/mime": "^2.0.3",
    "@types/node": "25.0.7",
    "@typescript-eslint/eslint-plugin": "8.56.1",
    "@typescript-eslint/parser": "8.56.1",
    "eslint": "10.0.2",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-prettier": "5.5.5",
    "eslint-plugin-sonarjs": "4.0.0",
    "husky": "9.1.7",
    "prettier": "^2.5.1",
    "prettier-eslint": "16.4.2",
    "ts-node": "~10.6.0",
    "typescript": "5.9.3",
    "typescript-eslint": "8.56.1"
  },
  "overrides": {
    "node-forge": "1.3.2",
    "glob": "12.0.0",
    "loader-utils": "2.0.4",
    "tar": "7.5.11",
    "cross-spawn": "6.0.6",
    "semver": "5.7.2",
    "diff": "4.0.3"
  }
}
